const DOMAIN_NAME_REGEX = /^((?!-)[a-z0-9-]{1,63}\.)+[a-z]{2,3}$/i;
/**
 * Validates that a comma-separated list of domain names is valid.
 */
export const Validator = {
    name: "domain-name-list",
    errorMessage: "Not all entered values are valid domain names.",
    validate: (value) => {
        const enteredDomainNames = value.split(",");
        const validDomainNames = enteredDomainNames.reduce((domainNames, domainName) => {
            const trimmedDomainName = domainName.trim();
            if (DOMAIN_NAME_REGEX.test(trimmedDomainName) ||
                trimmedDomainName === "totallynotprod.online")
                domainNames.push(trimmedDomainName);
            return domainNames;
        }, []);
        return enteredDomainNames.length === validDomainNames.length;
    },
};
